import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { NotificationModel } from '@shared/services/notifications/notifications.model';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatButtonModule, TranslateModule],
})
export class NotificationComponent {
  public readonly notification = inject<NotificationModel>(MAT_SNACK_BAR_DATA);
  private readonly _snackBar = inject<MatSnackBarRef<NotificationModel>>(MatSnackBarRef);

  public close() {
    this._snackBar.dismiss();
  }
}
